// extracted by mini-css-extract-plugin
export default {"container":"Products_container__z4UqN","products":"Products_products__klSYS","menu":"Products_menu__xIlpN","list":"Products_list__Xqf12","product":"Products_product__3Yp4F"};